import { Sidebar } from "../components/Navigation/Sidebar";
import { Header } from "../components/Header/Header";
import { SidebarProvider } from "../context/SidebarContext";

export const MainContent = ({ children }) => {
  return (
    <SidebarProvider>
      <Sidebar />
      <Header />
      <main className={`main`}>
        <div className="container-fluid pb-4 z-1">{children}</div>
      </main>
    </SidebarProvider>
  );
};
